import { ListItem, ListItemText, withStyles, StyledComponentProps, Divider, Typography } from '@material-ui/core';
import * as React from 'react';
import { reservation } from '../../../../model/reservation';
import { styles } from '../../styles';
import { getDateFromDayCode } from '../../../reservation/components/ReservationCalendar/commonReservation-utilities';
import moment from 'moment';

interface IContactReservationItemProps extends StyledComponentProps {
    reservation: reservation;
}



class ContactReservationItem extends React.Component<IContactReservationItemProps> {

    render() {
        const { reservation } = this.props;
        // console.log(reservation);
        return (
            <>
                <ListItem>
                    <ListItemText
                        primary={`Giorno : ${moment(getDateFromDayCode(reservation.dayCode)).format("DD/MM/YYYY")} ` +
                            `accesso dalle ${moment(reservation.reservationStart).format("HH:mm")} ` +
                            `alle ${moment(reservation.reservationEnd).format("HH:mm")}`}
                        secondary={
                            reservation.roomId === undefined ?
                            <>
                                <Typography>{`Prenotazione dalle  ` +
                                    `${moment(reservation.reservationStart).format("HH:mm")} ` +
                                    `alle ${moment(reservation.reservationStart).add(reservation.duration, "minute").format("HH:mm")}`}
                                </Typography>
                            </> 
                            : 
                            <Typography>{reservation.activityDescription}</Typography>
                        } 
                        />
                </ListItem>
                <Divider />
            </>
        );
    }
}

export default withStyles(styles as any)(ContactReservationItem);